/**
 * Authentication mode for the frontend.
 * 'demo' → profile selector (existing behavior)
 * 'jwt'  → email/password + Azure AD SSO
 * 'entra' → same as jwt (production alias)
 */
export const AUTH_MODE = import.meta.env.VITE_AUTH_MODE || 'demo';

/**
 * Azure AD / Entra ID configuration for SSO.
 * redirectUri is ALWAYS resolved dynamically from the current domain
 * so the same build works on localhost, dev, stg, and prd.
 */
export const AZURE_AD_CONFIG = Object.freeze({
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID || 'e52a611f-7c23-4b0a-87d6-cc84798a6827',
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '4ce51867-cb41-4d02-9c55-e9b3676ada97',
  get redirectUri() {
    return `${window.location.origin}/auth/callback`;
  },
});

export const VIA_ENDPOINTS = Object.freeze({
  dev: Object.freeze({
    application: 'https://dev.via.ucchristus.ai',
    api: 'https://api.dev.via.ucchristus.ai',
    database: 'db.dev.via.ucchristus.ai',
  }),
  stg: Object.freeze({
    application: 'https://stg.via.ucchristus.ai',
    api: 'https://api.stg.via.ucchristus.ai',
    database: 'db.stg.via.ucchristus.ai',
  }),
  prd: Object.freeze({
    application: 'https://via.ucchristus.ai',
    api: 'https://api.via.ucchristus.ai',
    database: 'db.via.ucchristus.ai',
  }),
});

// VIA opera con un unico ambiente activo: produccion. El frontend local
// (localhost) consume las APIs de produccion, igual que dev.via/stg.via cuando
// aun existan sus DNS. Un override explicito via VITE_BACKEND_URL siempre gana.
const API_BY_APPLICATION_HOST = Object.freeze({
  localhost: VIA_ENDPOINTS.prd.api,
  '127.0.0.1': VIA_ENDPOINTS.prd.api,
  'dev.via.ucchristus.ai': VIA_ENDPOINTS.dev.api,
  'stg.via.ucchristus.ai': VIA_ENDPOINTS.stg.api,
  'via.ucchristus.ai': VIA_ENDPOINTS.prd.api,
});

export function resolveBackendUrl(hostname = window.location.hostname) {
  const configured = import.meta.env.VITE_BACKEND_URL?.trim().replace(/\/$/, '');
  if (configured) return configured;
  return API_BY_APPLICATION_HOST[hostname] || VIA_ENDPOINTS.prd.api;
}
